import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Button, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { endOrderClarifyData } from '../../../../../services/ApiService'
import FormInput from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { REPORT_KEYS } from '../../../../SingleRequestReport/consts/request-report.keys'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'

const finishClarifyingSchema = z.object({
  comment: z.string(),
})

type FinishClarifyingForm = z.infer<typeof finishClarifyingSchema>

interface FinishClarifyingProps {
  request: RequestType
}

const FinishClarifying: React.FC<FinishClarifyingProps> = ({ request }) => {
  const invalidate = useInvalidateQueries()
  const {
    control,
    formState: { isValid },
    watch,
  } = useForm<FinishClarifyingForm>({
    mode: 'onChange',
    defaultValues: {
      comment: '',
    },
    resolver: zodResolver(finishClarifyingSchema),
  })

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['end-clarifying-installation-data'],
    mutationFn: () =>
      endOrderClarifyData({
        orderId: request.id,
        comment: watch('comment'),
      }),
    onSuccess: (data) => {
      newRequestDrawerStore.updateRequest(data)
      invalidate([
        'requests-table',
        'get-request-comments',
        REPORT_KEYS.GET_REPORT_TABLE,
        REPORT_KEYS.GET_REPORT,
      ])
    },
  })

  return (
    <Stack gap={'16px'} pb={'16px'} px={'16px'}>
      <Box>
        <FormInput
          control={control}
          fullWidth
          name='comment'
          label={''}
          placeholder='Введите комментарий'
          multiline
          rows={3}
        />
      </Box>
      <Button
        variant='contained'
        onClick={() => mutateAsync()}
        loading={isPending}
        disabled={!isValid}
        fullWidth
      >
        Закончить уточнение заявки
      </Button>
    </Stack>
  )
}

export default observer(FinishClarifying)
